import axios from '@/http/axios/index.js'


export default {
    getVendors(payload) {
        return axios.get('rps/vendors', { params: payload }).then(res => res.data)
    },
    updateVendor(payload) {
        return axios.post('rps/vendor/toggle', payload ).then(res => res.data)
    }
}